import { offset } from '@floating-ui/react';
import { useMemo, useState } from 'react';
import type { NavbarMenuItemV2ElementProps } from '../../NavbarMenuItem.type';
import { Accordion } from './Accordion';
import { FloatingDropdown } from './FloatingDropdown';

export function NavbarMenuItemDropdownV2(
  props: NavbarMenuItemV2ElementProps & {
    controlbyselected: boolean | string;
    labelComponent?: React.ReactNode;
    showCaret?: boolean;
    evaluatedHoverBorderRadius?: string | number;
  },
) {
  const [isOpen, setIsOpen] = useState(false);
  const { element, screen, attributes, children, evaluatedHoverBorderRadius } = props;

  const isUserButton = element.attrs?.type === 'user_button';
  const isDropdown = element.attrs?.type === 'dropdown';
  const isButton = element.attrs?.type === 'user_button' && element.attrs?.style === 'button';
  const isInEditor = attributes?.['data-render-dropdown-inline'] === 'true';

  const isDropdownFullWidth =
    element?.content?.[0]?.type === 'navbar_dropdown' && element.content[0]?.attrs?.style === 'full';
  const middlewares = useMemo(() => {
    if (isInEditor) return [];
    if (isUserButton && !isDropdownFullWidth) return [offset({ crossAxis: -8 })];
    return [];
  }, [isInEditor, isUserButton, isDropdownFullWidth]);

  if ((!isDropdown && !isUserButton) || (isUserButton && isButton)) {
    return null;
  }

  const dropdownNodeHeight =
    element.attrs?.type !== 'user_button' ? attributes?.['data-dropdown-node-height'] : undefined;
  const shouldForceOpen = isInEditor && attributes?.['data-is-open'] === 'true';

  // ======= Accordion =======
  const isShowOnMobile = element.attrs?.showOnMobile;
  const showDesktopDropdownForUserButton = isUserButton && isShowOnMobile;
  if (screen === 'mobile' && !showDesktopDropdownForUserButton) {
    return (
      <Accordion
        {...props}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        isInEditor={isInEditor}
        shouldForceOpen={shouldForceOpen}
        evaluatedHoverBorderRadius={evaluatedHoverBorderRadius}
      >
        {children}
      </Accordion>
    );
  }

  // ======= Floating Dropdown =======
  return (
    <FloatingDropdown
      {...props}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      shouldForceOpen={shouldForceOpen}
      isInEditor={isInEditor}
      dropdownNodeHeight={dropdownNodeHeight}
      middlewares={middlewares}
      showOnClick={screen === 'mobile'}
      evaluatedHoverBorderRadius={evaluatedHoverBorderRadius}
    >
      {children}
    </FloatingDropdown>
  );
}
